import type { PriceAreaProps, PriceAreaSize } from './PriceArea.types'
import { Tag, TagSize, Typography, TypographyVariant } from '@sunwebgroup/ui-components/uds'

import cn from 'classnames'
import React from 'react'
import styles from './PriceArea.module.css'

const PRICE_VARIANT: Record<PriceAreaSize, TypographyVariant> = {
  S: 'display-g-regular',
  M: 'display-f-regular',
  L: 'display-c-regular',
}

const TAG_SIZE: Record<PriceAreaSize, TagSize> = {
  S: 'S',
  M: 'S',
  L: 'M',
}

export function PriceArea({
  children,
  price,
  areaText,
  discounts,
  supportingText,
  size = 'S',
  className,
}: PriceAreaProps): React.JSX.Element {
  const hasDiscount = discounts != null && !!discounts.discountLabel

  return (
    <div className={cn(styles.wrapper, className)}>
      {hasDiscount && (
        <Tag size={TAG_SIZE[size]} variant="primary-tinted">
          {discounts.discountLabel}
        </Tag>
      )}
      <Typography className={styles.previousPrice} variant="body-xs-regular-snug">
        {areaText}
        {hasDiscount && (
          <Typography className={styles.originalPrice} variant="body-s-regular-snug">
            {discounts.originalPrice}
          </Typography>
        )}
      </Typography>
      <div className={styles.priceBox}>
        <Typography data-qa-price-value={price} variant={PRICE_VARIANT[size]}>
          {price}
        </Typography>
        {children}
      </div>
      {supportingText && (
        <Typography className={styles.supportingText} variant="body-xs-regular-tight">
          {supportingText}
        </Typography>
      )}
    </div>
  )
}

PriceArea.displayName = 'PriceArea'
